import { Action as ReduxAction } from 'redux'

import { ExportDialog } from '../constants'

/* Action definitions */

export interface ISetExportDialogVisibilityAction extends ReduxAction {
  // tslint:disable-next-line:no-reserved-keywords
  type: ExportDialog.SET_EXPORT_DIALOG_VISIBILITY,
  visibility: boolean
}

/* Action creators */

export function setExportDialogVisibilityAction(visibility: boolean): ISetExportDialogVisibilityAction {
  return {
    type: ExportDialog.SET_EXPORT_DIALOG_VISIBILITY,
    visibility,
  }
}

export type ExportDialogAction = ISetExportDialogVisibilityAction
